export const frameworkQuasarConfig = {
  dateFormat: 'dd/LL/yyyy',
  timeFormat: 'HH:mm',
  datetimeFormat: 'dd/LL/yyyy - HH:mm',
  datetimeIsoFormatConfig: {
    includeOffset: false,
    suppressMilliseconds: true,
  },
}
